export const NO_TITLE_LABEL = "(no title)";
export const CHAT_NO_TITLE_LABEL = "New chat";

export const getTitleOrNoTitle = (title: string | null | undefined): string => title?.trim() || NO_TITLE_LABEL;
